export default __webpack_public_path__ + "static/media/zip.c0db2986.svg";